function eventClick({ bucket_position, bucket_name, id, placement, position }) {
    let trackEvent = {
        bucket_position: bucket_position,
        bucket_name: bucket_name,
        id: id,
        page_type:  window.page_type || '4x4',
        page_value: window.page_value || 'Dört Dörtlük Kampanya - Hepsiburada',
        placement: placement,
        position: position
    }

    if (typeof window !== 'undefined' && typeof hepsiBus !== 'undefined') {
        hepsiBus.track('BannerClick', trackEvent);
    }
}

function eventView({ bucket_position, bucket_name, id, placement, position }) {
    let hbusData = {
        data: {
            eventNameForView: 'BannerView',
            bucket_position: bucket_position,
            bucket_name: bucket_name,
            id: id,
            page_type: window.page_type || '4x4',
            page_value: window.page_value || 'Dört Dörtlük Kampanya - Hepsiburada',
            placement: placement,
            position: position
        },
        type: 'herouselDetails',
    }
    hbusData.events = { view: ['davinci'] };

    return JSON.stringify(hbusData);
}

export {
    eventClick,
    eventView,
}


// WEBPACK FOOTER //
// ./src/analytics/davinci/davinci.js